var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15986 0.5C1.86243 0.5 0 2.36548 0 4.66667V21.3333C0 23.6345 1.86243 25.5 4.15986 25.5H20.3193C22.6167 25.5 24.4792 23.6345 24.4792 21.3333V4.66667C24.4792 2.36548 22.6167 0.5 20.3193 0.5H4.15986ZM3.3596 6.0925C3.3596 7.34949 4.31106 8.26807 5.48471 8.26807C6.65854 8.26807 7.60999 7.34949 7.60999 6.0925C7.60999 4.83569 6.65854 3.91606 5.48471 3.91606C4.31106 3.91606 3.3596 4.83569 3.3596 6.0925ZM17.2311 21.9857H20.9173V14.5392C20.9173 10.8615 18.6946 9.60716 16.6378 9.60716C14.7359 9.60716 13.4439 10.8726 13.0872 11.6138V9.94557H9.54219V21.9857H13.2283V15.4579C13.2283 13.7174 14.3005 12.8709 15.3943 12.8709C16.4288 12.8709 17.2311 13.4693 17.2311 15.4096V21.9857ZM7.32769 9.93629V21.9764H3.64174V9.93629H7.32769Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.b6ca7d88db1f5bd966471a73a79b7ca6.svg";
export { ForwardRef as ReactComponent };